export default "__VITE_ASSET__19fc398c__"